import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeaturedArticles = ({ articles, onArticleClick }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getCategoryColor = (category) => {
    const colorMap = {
      'getting-started': 'bg-primary-100 text-primary',
      'booking-vendors': 'bg-secondary-100 text-secondary',
      'account-management': 'bg-success-100 text-success',
      'vendor-registration': 'bg-warning-100 text-warning',
      'billing-payments': 'bg-info-100 text-info',
      'technical-support': 'bg-danger-100 text-danger'
    };
    return colorMap[category] || 'bg-surface-100 text-text-secondary';
  };

  const getCategoryName = (category) => {
    const nameMap = {
      'getting-started': 'Getting Started',
      'booking-vendors': 'Booking Vendors',
      'account-management': 'Account Management',
      'vendor-registration': 'Vendor Registration',
      'billing-payments': 'Billing & Payments',
      'technical-support': 'Technical Support'
    };
    return nameMap[category] || 'General';
  };

  return (
    <section className="py-16 bg-surface-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl text-text-primary mb-4">
            Featured Articles
          </h2>
          <p className="text-lg text-text-secondary">
            Most helpful articles from our community
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles?.map((article) => (
            <article
              key={article?.id}
              onClick={() => onArticleClick?.(article?.id)}
              className="bg-white rounded-xl shadow-soft hover:shadow-medium transition-all duration-200 cursor-pointer overflow-hidden group"
            >
              <div className="p-6">
                <div className="flex items-center space-x-2 mb-3">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getCategoryColor(article?.category)}`}>
                    {getCategoryName(article?.category)}
                  </span>
                  <span className="text-text-muted text-xs">
                    {formatDate(article?.lastUpdated)}
                  </span>
                </div>
                
                <h3 className="font-heading font-semibold text-xl text-text-primary mb-3 group-hover:text-primary transition-colors">
                  {article?.title}
                </h3>
                
                <p className="text-text-secondary mb-4">
                  {article?.excerpt}
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4 text-text-muted text-sm">
                    <div className="flex items-center space-x-1">
                      <Icon name="Clock" size={14} />
                      <span>{article?.readTime}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="Eye" size={14} />
                      <span>{article?.views?.toLocaleString()}</span>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-1 text-success text-sm">
                    <Icon name="ThumbsUp" size={14} />
                    <span>{article?.helpful}</span>
                  </div>
                </div>
              </div>
              
              <div className="px-6 pb-6">
                <div className="w-full h-px bg-border mb-4"></div>
                <div className="flex items-center justify-between">
                  <span className="text-text-muted text-sm">
                    Was this helpful?
                  </span>
                  <div className="flex items-center space-x-2">
                    <button className="text-text-muted hover:text-success transition-colors">
                      <Icon name="ThumbsUp" size={16} />
                    </button>
                    <button className="text-text-muted hover:text-danger transition-colors">
                      <Icon name="ThumbsDown" size={16} />
                    </button>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Button
            variant="outline"
            size="lg"
            iconName="BookOpen"
            onClick={() => console.log('Browse all articles')}
          >
            Browse All Articles
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedArticles;